module.exports = __webpack_public_path__ + "static/media/rectangle-24.68754373.svg";